import { render, staticRenderFns } from "./JustificativaNaoVendaDetalhada.vue?vue&type=template&id=5c69ae92&scoped=true"
import script from "./JustificativaNaoVendaDetalhada.vue?vue&type=script&lang=js"
export * from "./JustificativaNaoVendaDetalhada.vue?vue&type=script&lang=js"
import style0 from "./JustificativaNaoVendaDetalhada.vue?vue&type=style&index=0&id=5c69ae92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c69ae92",
  null
  
)

export default component.exports